

















































































































































































































import InvoicePartySheet from "@/components/invoice/InvoicePartySheet.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { IReport } from "@/models/report.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import PartnerReportRepairEstimateUpdateDialog from "../partner/report/v2/repair/PartnerReportRepairEstimateUpdateDialog.vue";
import ReportAppraisalEstimateSendDialog from "../partner/report/v2/repair/ReportAppraisalEstimateSendDialog.vue";
import SharedContentSideCard from "../partner/SharedContentSideCard.vue";
import MExpansion from "../utility/mmmint/MExpansion.vue";
import MIconButton from "../utility/mmmint/MIconButton.vue";
import { handleError } from "@/lib/utility/handleError";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";

@Component({
  components: {
    MNoContent,
    MTextField,
    MIconButton,
    MSelect,
    InvoicePartySheet,
    LineItemsForm,
    SelectAssignees,
    MExpansion,
    SharedContentSideCard,
    ReportAppraisalEstimateSendDialog,
    PartnerReportRepairEstimateUpdateDialog,
    ConfirmActionDialog
  },
  filters: {}
})
export default class RepairEstimateSheet extends mixins(PermissionMixin) {
  private readonly RequestStatusEnum = RequestStatusEnum;
  private readonly TemplateKeyEnum = PreselectTemplateKeysEnum;

  @Prop({ required: true }) readonly estimate!: IRepairEstimate;
  @Prop() readonly report?: IReport;
  @Prop({ type: Boolean, default: false }) readonly hideGoToDetail!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideSharingLink!: boolean;

  showDocument = false;
  showPositions = false;
  isUpdateDialog = false;
  isSendDialog = false;
  isDeleteDialogActive = false;
  isDeleteLoading = false;

  sharedContentSideCardItem?: ISharedContent | null = null;
  localEstimate: IRepairEstimate = new RepairEstimate({});

  get filters() {
    const filter: IPageFilterElement[] = [];
    if (!this.report) return filter;

    filter.push(new PageFilterElement({ value: this.report.id, key: "refs.refId", operation: "$eq" }));

    return filter;
  }

  openUpdateDialog() {
    if (this.canUpdateAppraisal) {
      this.isUpdateDialog = true;
    }
  }

  openDeleteDialog() {
    if (this.canDeleteRepairEstimate) {
      this.isDeleteDialogActive = true;
    }
  }

  created() {
    this.localEstimate = this.estimate;
  }

  @Watch("estimate", { immediate: true, deep: true })
  onEstimateChanged(val: IRepairEstimate) {
    this.localEstimate = val;
  }

  emitUpdateEstimate() {
    this.$emit("update:estimate", this.localEstimate);
  }

  emitDeleteEstimate() {
    this.$emit("delete", this.localEstimate);
  }

  get statusItems() {
    return Object.values(RequestStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.RequestStatusEnum.${value}`)
    }));
  }

  async onAssigneesUpdate(assignees: []) {
    if (!this.canUpdateRepairEstimate) return;
    const estimate = this.localEstimate;
    if (!estimate) return;
    await estimate.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.canUpdateRepairEstimate) return;
    const estimate = this.localEstimate;
    if (!estimate) return;
    await estimate.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.canUpdateRepairEstimate) return;
    const estimate = this.localEstimate;
    if (!estimate) return;
    await estimate.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }

  async onDelete() {
    this.isDeleteLoading = true;
    try {
      await this.localEstimate?.delete().then(() => {
        this.isDeleteLoading = false;
        this.isDeleteDialogActive = false;
        this.$toast.success("👍");
      });
      this.emitDeleteEstimate();
    } catch (error) {
      handleError(error);
    } finally {
      this.isDeleteLoading = false;
      this.isDeleteDialogActive = false;
    }
  }

  goToDetail() {
    if (!this.canUpdateRepairEstimate) return;
    const estimate = this.localEstimate;
    if (!estimate) return;
    estimate.goTo(this.$router).detail();
  }
}
